import config from '../config';

export const resetRoutingProfiles = async (activeOnly: boolean): Promise<void> => {
  const response = await fetch(config.catoApiUrl + `/reset-routing-profiles?activeOnly=${String(activeOnly)}`, {
    method: 'POST'
  });

  if (!response.ok) {
    const errorText = await response.text().catch(() => 'Unknown error');
    throw new Error(`Failed to reset routing profiles: ${response.status} ${response.statusText} - ${errorText}`);
  }
};
